import { useState, useEffect, useContext } from 'react'
import { ThemeContext } from '../Helper/Context'
import Validation from "./Validation";
import useFetch from './useFetch'


const Debitcard = ({ slot, hidePopup, closePopup }) => {
    const { setShowSignin, mainState, setMainState } = useContext(ThemeContext);
    const { setShowLoader } = useContext(ThemeContext);
    const [{ response }, dofetch] = useFetch();
    const [errors, setErrors] = useState({ errors: true })
    const [formFields, setFormFields] = useState({
        cardNumber: {
            value: '',
            required: true,
            type: 'text'
        },

    })

    // console.log(slotId)

    const handleChange = (e) => {
        setFormFields(prevState => ({
            ...prevState,
            [e.target.name]: {
                ...prevState[e.target.name], value: e.target.value
            }
        }))
    }

    const handlePaynow = (e) => {
        e.preventDefault();
        setErrors(Validation(formFields));
        // setMainState({...mainState,section:'enrolment'})
        // setShowLoader(true);
        // hidePopup();

    }

    useEffect(() => {
        if (!errors) {
            setErrors(true);
            console.log(formFields)
        }
    }, [errors]);


    return (
        <div className="perfectgym-popup" onClick={e => { hidePopup(e) }}>
            <div className="popup-content">
                <div className="closebtn" onClick={(e) => closePopup(e)}><i className="fal fa-times"></i></div>
                <h2>Credit card payment</h2>

                <div className="form">
                    <div className="form-row">
                        <div className="form-element">
                            <label className="EditingFormLabel" htmlFor="cardNumber">Card Number*</label>
                            <div className="EditingFormControlNestedControl editing-form-control-nested-control">
                                <input type="text" className="form-control" id="cardNumber" name="cardNumber" placeholder="Type your credit/debit card number"
                                    value={formFields.cardNumber.value}
                                    onChange={e => handleChange(e)} />
                            </div>
                            {errors.cardNumber &&
                                <span className="EditingFormErrorLabel">Please enter credit/debit card number</span>
                            }
                        </div>
                    </div>

                    <div className="form-row form-row-submit">
                        <div className="form-element">
                            <div className="btn-wrapper">
                                <button className="FormButton btn" value="Done" onClick={(e) => handlePaynow(e)} >Pay now</button>
                                <button className="btn btn-border" onClick={(e) => closePopup(e)}>Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>


                {/* <div className="btn-wrapper">
                    <button className="btn btn-border" onClick={(e) => closePopup(e)}>back</button>
                    <button className="btn" onClick={e => handlePaynow()}>Pay now</button>
                </div> */}
            </div>
        </div>
    )
}
export default Debitcard
